import React, { useEffect, useState } from "react";
import loadConfig from "../../Services/apiService";
import { useDispatch, useSelector } from "react-redux";
import InputAHSF from "../../Components/InputAHSF";
import { ValidationAllPageReports } from "../../Redux/Reducers/ReportStage/ValidateReportStage";
import {
  GetAllPR_InformationWebsiteByPR_ReportsStagesGuid,
  GetSpecificRowNoteInformationWebsite,
  UpdatePR_InformationWebsite,
} from "../../Redux/Reducers/ReportStage/InformationWebsite";
import { useParams } from "react-router-dom";
import { decryptToken } from "../../Services/Account/EncryptionParams";

const InformationWebsitePage = (props) => {
  const reportStageGuid=useSelector((state)=>state.Stages.reportStageGuid)
  const [jsonData, setJsonData] = useState();
  const [InformationWebsiteList, setInformationWebsiteList] = useState([]);
  const [Refresh, setRefresh] = useState(0);
  console.log(reportStageGuid,"sddwsdwdwdwdwd");
  
  const getJsonData = async () => {
    let jsonData = await loadConfig();
    setJsonData(jsonData);
  };

  useEffect(() => {
    getJsonData();
  }, []);

  const dispatch = useDispatch(); // Used to dispatch Redux actions.
  const state = useSelector((state) => {
    return {
      ValidateReportStage: state.ValidateReportStage.ValidateReportStage,
      OneSpecificRowNoteInformationWebsite:
        state.InformationWebsite
          .OneSpecificRowNoteInformationWebsite,
          
    };
  });

  const getData = async () => {
    let data = await dispatch(
      GetAllPR_InformationWebsiteByPR_ReportsStagesGuid(
        {
          specificOrMulti: true,
          stageGuid: props.pR_ReportsStagesGuid,
          reportGuid: props.reportId,
          applicationInfoGuid: "string"
        }
      )
    );
    if (data?.payload.length) {
      setInformationWebsiteList(data?.payload);
    }
  };

  useEffect(() => {
    getData();
  }, [Refresh,reportStageGuid]);

  const UpdateWebsite = async (column, number) => {
    const update = await dispatch(
      UpdatePR_InformationWebsite({
        pR_InformationWebsiteId: column.pR_InformationWebsiteId,
        pR_InformationWebsiteNameId: column.pR_InformationWebsiteNameId,
        number: number == "" ? null : number,
        pR_ReportsStagesGuid: column.pR_ReportsStagesGuid,
      })
    );
    if (update.payload == "success") {
      setRefresh(Refresh + 1);
    }
  };
  let { stageGuid } = useParams();

  stageGuid = decryptToken(stageGuid);
  // useEffect(() => {
  //   dispatch(
  //     GetSpecificRowNoteInformationWebsite({
  //       pR_ReportsStagesGuid: stageGuid,
  //       pR_NotesTableId: "0be3dc0f-5c01-433e-8267-bad54acac4cc",
  //     })
  //   );
  // }, []);
console.log(state.OneSpecificRowNoteInformationWebsite
  );

  return (
    <>
      <div id="EvaluationInformationId" className="ContinerMarks-section">
        <p className="title">{jsonData?.InformationWebsite?.nameAR}</p>
        <div className="ContinerTableYesNo">
          <table>
            <thead>
              <tr key="3">
                <th>{jsonData?.RequiredInformation?.nameAR}</th>
                <th>{jsonData?.RF_Number?.nameAR}</th>
              </tr>
            </thead>
            <tbody>
              {InformationWebsiteList &&
                InformationWebsiteList.map((elem, index) => {
                  return (
                    <>
                      <tr key={elem.pR_InformationWebsiteId}>
                        <td>{elem.informationWebsiteName}</td>

                        <td>
                          <InputAHSF
                            fieldsName="yesNoTableDropDown"
                            type="number"
                            show={true}
                            disabled={
                              !props.canEdit
                            }
                            hidelable={true}
                            className="form_control_input"
                            defaultValue={elem.number}
                            style={{ width: "100%" }}
                            onChange={async (e) => {
                              await UpdateWebsite(elem, e.target.value);
                            }}
                            onBlur={async (e) => {
                              await UpdateWebsite(elem, e.target.value);
                            }}
                            showValidationMessage={
                              state.ValidateReportStage
                                ? state.ValidateReportStage.includes(
                                    `InformationWebsiteNumber` +
                                      elem.pR_InformationWebsiteId
                                  )
                                : false
                            }
                            validationMessage="حقل اجباري"
                          />
                        </td>
                      </tr>
                    </>
                  );
                })}
            </tbody>
          </table>
        </div>
      </div>
    </>
  );
};

export default InformationWebsitePage;
